module.exports = __webpack_public_path__ + "img/zs_icon_dz.608a818a.svg";